type ToggleSwitchProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  ariaLabel?: string;
};

export default function ToggleSwitch({
  checked,
  onChange,
  ariaLabel,
}: ToggleSwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      onClick={() => onChange(!checked)}
      className={`relative w-12 h-7 rounded-full transition-all cursor-pointer ${
        checked ? "bg-indigo-500" : "bg-gray-300"
      }`}
    >
      <div
        className={`absolute top-0.5 w-6 h-6 bg-white rounded-full shadow-md transition-all ${
          checked ? "left-[22px]" : "left-0.5"
        }`}
      ></div>
    </button>
  );
}
